import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { NavLink, RouteComponentProps } from 'react-router-dom';
import * as Components from '../../components/index';
import * as Models from '../../models/index';
import * as ActionCreators from '../../actions/action.creators';
import Icon from '../../components/icon';
import PopOver from '../../components/popover';

import './index.scss';

interface StateProps {
	appName: string;
	appVersion: string;
	errors: string[];
	isLogged: boolean;
	isMobileMode: boolean;
	canChangeUserName: boolean;
	isProcessing: boolean;
	loggedUsername: string;
	warningMessages: string[];
	username: string;
	password: string;
	isExpiredPassword: boolean;
	showForgotPassword: boolean;
	isBrowserRegistered: boolean;
	showForgotUsernameMessage: boolean;
	forgotUsernameMessage: string;
	onlySSOLoginAllowed: boolean;
}
interface DispatchProps {
	loginActions: typeof ActionCreators.Login;
	showForgotUserMess: typeof ActionCreators.showForgotUserMessage;
}
const mapStateToProps = (state: Models.StoreState): StateProps => ({
	appName: state.shell.appName,
	appVersion: state.shell.appVersion,
	errors: state.login.errors,
	loggedUsername: state.login.loggedFullName,
	isLogged: state.login.isSuccess,
	isMobileMode: state.shell.isMobileMode,
	isProcessing: state.login.processing,
	warningMessages: state.messages.warningMessages,
	canChangeUserName: state.shell.redirectUserName == null,
	username: state.shell.redirectUserName || state.login.userName,
	password: state.login.password,
	isExpiredPassword: state.login.isExpiredPassword,
	showForgotPassword: state.shell.turnOnForgotPassword,
	isBrowserRegistered: state.shell.isBrowserRegistered,
	showForgotUsernameMessage: state.shell.showForgotUsernameMessage,
	forgotUsernameMessage: state.shell.forgotUsernameMessage,
	onlySSOLoginAllowed: state.shell.onlySSOLoginAllowed,
});
const mapDispatchToProps = (dispatch: any): DispatchProps => ({
	loginActions: bindActionCreators<any>(ActionCreators.Login, dispatch),
	showForgotUserMess: bindActionCreators<any>(ActionCreators.showForgotUserMessage, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	class LoginIndex extends React.Component<StateProps & DispatchProps & RouteComponentProps<any>, any> {
		renderForgotPassword = () => {
			if (!this.props.showForgotPassword) return null;
			return (
				<NavLink className='forgot-pwd' to='/password recovery'>
					Forgot your password?{' '}
				</NavLink>
			);
		};

		goToClockEntry() {
			window.location.href = '/ClockEntry';
		}

		signInWithYum() {
			window.location.href = '/Yum/Login';
		}
		getErrorFromUrl() {
			var errorCode = getQueryParamValue('error');
			if (!Boolean(errorCode)) return null;

			switch (errorCode.replace(/[^a-zA-Z0-9_]/g, '')) {
                case 'self_service_requested': {
					window.location.hash = "#yum_sso_id_self_service"
					return;
				}
                case 'sso_user_not_exists':
					return 'Tracks access is not available for your SSO user, please contact your support center for access';
				case 'user_login_not_allowed_to_tracks':
					return `Tracks access is not available for your user, please login to pretracks app`;
				case 'user_login_not_allowed_to_pretracks':
					return `Pretracks access is not available for your user, please login to Tracks app`;
				default:
					return 'Unknown error';
			}
		}
		getErrors() {
			var errors = this.props.errors.concat(this.props.warningMessages);
			if (errors.length === 0) {
				var errorFromUrl = this.getErrorFromUrl();
				if (errorFromUrl) errors.push(errorFromUrl);
			}
			return errors;
		}
		render() {
			var errors = this.getErrors();
			const showBasicLoginOptions = this.props.onlySSOLoginAllowed !== null && !this.props.onlySSOLoginAllowed;

			return (
				<Components.LayoutBlock verticalAlign='center' align='center' fill className='login-view-wrapper'>
					{this.props.onlySSOLoginAllowed !== null && (
						<Components.LayoutBlock className='view login-view' style={this.props.onlySSOLoginAllowed ? { minHeight: 'auto' } : null}>
							<Components.LayoutBlock inline>
								<Components.LayoutBlock className='logo' />
								<Components.LayoutBlock className='app-info'>
									<Components.Label className='app-name'>{this.props.appName}</Components.Label>
									<Components.Label className='app-version'> {this.props.appVersion}</Components.Label>
								</Components.LayoutBlock>
							</Components.LayoutBlock>

							{this.props.canChangeUserName ? null : (
								<Components.Label className='login-proceed-alert'>Please enter your credentials before proceeding.</Components.Label>
							)}
							{showBasicLoginOptions && (
								<>
									<Components.Textbox
										icon={{ icon: 'user' }}
										placeholder='enter username'
										onSubmit={this.props.loginActions.login}
										readonly={!this.props.canChangeUserName}
										onChange={this.props.loginActions.changeUsername}
										value={this.props.username}
									/>
									<Components.Textbox
										icon={{ icon: 'lock' }}
										placeholder='enter password'
										onSubmit={this.props.loginActions.login}
										onChange={this.props.loginActions.changePassword}
										type='password'
										value={this.props.password}
									/>
									<Components.Button
										className='login-button'
										busy={this.props.isProcessing || this.props.isLogged}
										busyTitle={this.props.isLogged ? 'Redirecting...' : 'Processing...'}
										onClick={this.props.loginActions.login}
									>
										Login
									</Components.Button>
								</>
							)}

							{this.props.isMobileMode ? (
								<div className='login-notice'>
									By logging in, you acknowledge that using Tracks Mobile is voluntary and not a condition of employment. Message
									and data rates may apply.
								</div>
							) : null}

							<Components.Button className='nav-to-clock-entry' onClick={this.signInWithYum}>
								<Icon icon='review' /> SIGN IN WITH YUM
							</Components.Button>

							{!this.props.isBrowserRegistered ? null : (
								<Components.Button className='nav-to-clock-entry' onClick={this.goToClockEntry}>
									<Icon icon='clock' /> Go to Clock Entry
								</Components.Button>
							)}

							{showBasicLoginOptions && (
								<>
									<Components.LayoutBlock className='login-links'>
										{this.renderForgotPassword()}
										<PopOver opened={this.props.showForgotUsernameMessage} onDismiss={this.props.showForgotUserMess}>
											{this.props.forgotUsernameMessage}
										</PopOver>
									</Components.LayoutBlock>

									<Components.LayoutBlock onClick={this.props.showForgotUserMess}>
										<Components.Label className='forgot-pwd'>Forgot your username?</Components.Label>
									</Components.LayoutBlock>
								</>
							)}
							{errors.length > 0 && <Components.ListBox items={errors} listItemStyle='error-message' />}
						</Components.LayoutBlock>
					)}
				</Components.LayoutBlock>
			);
		}
	}
);

const getQueryParamValue = (key: string) => {
	var queryParams: { [key: string]: string } = {};
	window.location.href
		.substring(window.location.href.indexOf('?') + 1)
		.split('&')
		.forEach(x => (queryParams[x.split('=')[0]] = x.split('=')[1]));
	return queryParams[key];
};
